import type { ApiResponse, BannerConfigResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

/** Banner 引擎配置：全域預設、組織覆蓋，帶 providerId 時多回該組織實際生效的配置 */
export function useBannerConfig(providerId?: number) {
  const { token } = useAuth()
  const url = providerId ? `/api/banner_config?provider_id=${providerId}` : '/api/banner_config'
  const { data, error, mutate, isLoading } = useGet<ApiResponse<BannerConfigResponse>>(
    token ? url : null,
    undefined,
    token ?? '',
  )
  return { config: data?.data, isLoading, isError: error, mutate }
}
